<template>
    <a-icon
        v-on:click="replay"
        class="play-button"
        type="undo" />
</template>

<script>
 import Vue from 'vue';
 import EventBus from "../event/event-bus.js"
 import Icon from "ant-design-vue/lib/icon";

 Vue.component(Icon.name, Icon);

 export default {
     name: 'ReplayButton',
     props: {
     },
     components: {
     },
     methods: {
         replay() {
             EventBus.$emit("replayVideo")
         }
     }
 }
</script>

<style scoped>
 .play-button {
     font-size: 24px;
     color: #CCC;
     margin-right: 10px;
 }
</style>
